module.exports = __webpack_public_path__ + "img/disaster_relief-stage_1.1.a83709fe.jpg";